export default __webpack_public_path__ + "static/media/DarkUser.1284a2fb.svg";